export const update_unit_order = `subscription update_unit_order{
    update_unit_order{
        transaction_code
        status
        direction
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        count
        fulfilled_count
        validity_start
        validity_end
        deal_price
        purchase_value
    }
}`;
